import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-sm' : 'bg-black/60 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-4xl font-light text-zinc-100 tracking-wider" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Pazzo
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-10">
            <button
              onClick={() => scrollToSection('home')}
              className="text-zinc-300 hover:text-white transition-colors duration-200 text-sm tracking-wide uppercase"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-zinc-300 hover:text-white transition-colors duration-200 text-sm tracking-wide uppercase"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-zinc-300 hover:text-white transition-colors duration-200 text-sm tracking-wide uppercase"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('locations')}
              className="text-zinc-300 hover:text-white transition-colors duration-200 text-sm tracking-wide uppercase"
            >
              Location
            </button>
            <button
              onClick={() => scrollToSection('reservation')}
              className="text-zinc-300 hover:text-white transition-colors duration-200 text-sm tracking-wide uppercase"
            >
              Reserve
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-zinc-100 hover:text-zinc-300 transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-md border-t border-zinc-800">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left py-2 text-zinc-300 hover:text-white transition-colors text-sm tracking-wide uppercase"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left py-2 text-zinc-300 hover:text-white transition-colors text-sm tracking-wide uppercase"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left py-2 text-zinc-300 hover:text-white transition-colors text-sm tracking-wide uppercase"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('locations')}
              className="block w-full text-left py-2 text-zinc-300 hover:text-white transition-colors text-sm tracking-wide uppercase"
            >
              Location
            </button>
            <button
              onClick={() => scrollToSection('reservation')}
              className="block w-full text-left py-2 text-zinc-300 hover:text-white transition-colors text-sm tracking-wide uppercase"
            >
              Reserve
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;